// CR-404 FR-1

/** Max automatic retries for DRM-protected streams (CR-404 FR-1). */
export const MAX_RETRIES_DRM = 2

/** Max automatic retries for non-DRM streams (CR-404 FR-1). */
export const MAX_RETRIES_NON_DRM = 3

/** Fixed delay between retries 2+ for DRM streams (ms). */
export const RETRY_DELAY_DRM_MS = 1500

/** Fixed delay between retries 2+ for non-DRM streams (ms). */
export const RETRY_DELAY_NON_DRM_MS = 1000

export const MANUAL_RETRY_COOLDOWN_MS = 30_000

// error.code strings produced by tria's error-map.ts + pureya's beforeerror hook
export const RECOVERABLE_ERROR_CODES = new Set([
  'NE001', // MEDIA_ERR_NETWORK (covers 502/503/504 at stream level)
  'PE003', // MEDIA_ERR_CUSTOM
  'PE004', // MEDIA_ERR_ABORTED / Request Cancelled
  'PE010', // PLAYER_ERR_TIMEOUT / REQUEST_TIMEOUT_ERROR
])

/**
 * FP-4176 ER: these codes show the player error overlay only — no Smart-Restart
 * auto-retry and no Try again button (even if they arrive mid-RETRYING).
 * FP-4235 adds PE005.
 */
export const NO_RETRY_ERROR_CODES = new Set([
  'DR001', // DRM failure
  'SE001', // WBS/API server errors
  'GE001', // WBS geo
  'AE402', // payment required
  'AE403', // access error
  'SE404', // not found (e.g. after VHS playlist policy exhaustion)
  'SE500', // API error
  'PE006', // format not supported
  'PE005', // MEDIA_ERR_DECODE — retries loop forever (FP-4235)
])
// Other non-recoverable (not in NO_RETRY): CSL433 (CSL feature), EC451 (geoblock)
